import ApplicationSerializer from './application';
import { get } from '@ember/object';

const transformUserDataObjectToArray = (resource) => {
  if (!resource) {
    return;
  }

  const userData = get(resource, 'attributes.user-data');

  if (userData && !Array.isArray(userData)) {
    let userDataArray = [];

    for (const prop in userData) {
      userDataArray = userDataArray.concat({ field: prop, value: userData[prop] });
    }

    resource.attributes['user-data'] = userDataArray;
  }
};

export default ApplicationSerializer.extend({
  get include() {
    return ['agreeableNdas'];
  },

  serialize(primaryResource /* , request */) {
    const payload = ApplicationSerializer.prototype.serialize.apply(this, arguments);

    if (primaryResource.modelName === 'entry') {
      if (Array.isArray(payload.data)) {
        payload.data.forEach((resource) => transformUserDataObjectToArray(resource));
      } else {
        transformUserDataObjectToArray(payload.data);
      }
    }

    return payload;
  },
});
